/* Eigener Cookie-Banner (Booksbaum/Puro) — baut auf Shopifys offizieller
 * Customer-Privacy-API auf (Muster: hoerclub cookie-banner.js). Der Banner
 * erscheint nur, wenn eine Einwilligung erforderlich und noch keine Wahl
 * getroffen ist; jede Aktion wird über setTrackingConsent an Shopify
 * durchgereicht, sodass Pixel/Apps die Entscheidung respektieren.
 * Wiederaufruf jederzeit über Elemente mit [data-cookie-settings]. */
(function () {
  'use strict';

  if (customElements.get('rp-cookie-banner')) return;

  class RpCookieBanner extends HTMLElement {
    connectedCallback() {
      if (this.initialisiert) return;
      this.initialisiert = true;

      this.wiederaufruf = false;
      this.haupt = this.querySelector('[data-cb-haupt]');
      this.details = this.querySelector('[data-cb-details]');

      this.verdrahten();

      // Wiederaufruf über Footer-Link o. Ä. — delegiert, funktioniert überall.
      document.addEventListener('click', (e) => {
        var ausloeser = e.target.closest('[data-cookie-settings]');
        if (!ausloeser) return;
        e.preventDefault();
        this.wiederaufruf = true;
        this.ladeApi(() => this.oeffnen(true));
      });

      if (this.testModus || window.Shopify && window.Shopify.designMode) {
        if (this.testModus) this.oeffnen(false);
        return;
      }

      this.ladeApi(() => {
        var cp = window.Shopify.customerPrivacy;
        if (!cp) return;
        if (!cp.userCanBeTracked() && cp.getTrackingConsent() === 'no_interaction') {
          setTimeout(() => this.oeffnen(false), this.verzoegerung * 1000);
        }
      });
    }

    get testModus() {
      return this.getAttribute('data-test-mode') === 'true';
    }

    get verzoegerung() {
      return parseInt(this.getAttribute('data-delay') || '2', 10);
    }

    ladeApi(fertig) {
      if (window.Shopify && window.Shopify.customerPrivacy) { fertig(); return; }
      if (!window.Shopify || !window.Shopify.loadFeatures) { return; }
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: fertig
      }]);
    }

    verdrahten() {
      var self = this;

      this.addEventListener('click', function (e) {
        // Richtext-Konvention: Links auf #ablehnen / #details im Textblock.
        var link = e.target.closest('a[href="#ablehnen"], a[href="#details"]');
        if (link) {
          e.preventDefault();
          if (link.getAttribute('href') === '#ablehnen') self.entscheide(false);
          else self.zeigeDetails(true);
          return;
        }
        var knopf = e.target.closest('[data-consent]');
        if (knopf) {
          e.preventDefault();
          var art = knopf.getAttribute('data-consent');
          if (art === 'alle') self.entscheide(true);
          else if (art === 'ablehnen') self.entscheide(false);
          else if (art === 'auswahl') self.entscheideAuswahl();
          else if (art === 'details') self.zeigeDetails(true);
          else if (art === 'zurueck') self.zeigeDetails(false);
          else if (art === 'schliessen') self.schliessenOhneWahl();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.hidden) self.schliessenOhneWahl();
      });
    }

    oeffnen(vorbelegen) {
      this.zeigeDetails(false);
      if (vorbelegen) this.togglesVorbelegen();
      var schliesser = this.querySelector('[data-consent="schliessen"]');
      if (schliesser) schliesser.hidden = !this.wiederaufruf;
      this.hidden = false;
      document.body.classList.add('rp-cb-offen');
      var fokusziel = this.querySelector('[data-consent="alle"]') || this;
      fokusziel.focus && fokusziel.focus();
    }

    schliessen() {
      this.hidden = true;
      document.body.classList.remove('rp-cb-offen');
    }

    // Schliessen ohne Entscheidung: nur im Wiederaufruf erlaubt (Erstbesuch
    // verlangt eine Wahl — gleichwertig Annehmen/Ablehnen, kein Dark Pattern).
    schliessenOhneWahl() {
      if (this.wiederaufruf || this.testModus) this.schliessen();
    }

    zeigeDetails(an) {
      if (this.haupt) this.haupt.hidden = !!an;
      if (this.details) this.details.hidden = !an;
    }

    togglesVorbelegen() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.currentVisitorConsent) return;
      var stand = cp.currentVisitorConsent();
      var statistik = this.querySelector('[data-kategorie="statistik"]');
      var marketing = this.querySelector('[data-kategorie="marketing"]');
      if (statistik) statistik.checked = stand.analytics === 'yes';
      if (marketing) marketing.checked = stand.marketing === 'yes';
    }

    entscheide(einwilligung) {
      var self = this;
      this.ladeApi(function () {
        var cp = window.Shopify.customerPrivacy;
        if (cp) cp.setTrackingConsent(einwilligung, function () {});
      });
      this.schliessen();
    }

    entscheideAuswahl() {
      var statistik = this.querySelector('[data-kategorie="statistik"]');
      var marketing = this.querySelector('[data-kategorie="marketing"]');
      var analytics = !!(statistik && statistik.checked);
      var werbung = !!(marketing && marketing.checked);
      this.ladeApi(function () {
        var cp = window.Shopify.customerPrivacy;
        if (cp) {
          cp.setTrackingConsent({
            analytics: analytics,
            marketing: werbung,
            preferences: true,
            sale_of_data: werbung
          }, function () {});
        }
      });
      this.schliessen();
    }
  }

  customElements.define('rp-cookie-banner', RpCookieBanner);
})();
